import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import { createSlug, fetchProductBySlugOrId } from "../Helper/index.js";
const logo =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742196577/logo_bnny8z.png";
const das9100 =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275473/01_ttucqd.png";
const das9100maize =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275471/02_ihme6c.png";
const das7100 =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275479/03_kmjkoe.png";
const das3100 =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275480/04_ys03lq.png";
const das912tdc =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275490/05_obkzgm.png";
const das9124wd =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275490/05_obkzgm.png";
const das731 =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275482/06_dobdk1.png";
const das726 =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275483/07_vjswu3.png";
const dasmaizehdr =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275469/08_jhedhl.png";
const rotavator =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275470/09_rpv1uw.png";
const daslll =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275465/010_kl81yn.png";
const dasss =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275488/011_oml9nd.png";
const dassr =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275474/012_kxc8pf.png";
const dassb =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275475/013_pwxaqp.png";
const dasrb =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275474/014_we9pwi.png";
const dashr =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275469/015_mm1osk.png";
const dasztd =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275487/016_mqpslx.png";
const dasdd =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275480/017_sxqk5a.png";
const daspsc =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275466/018_iqp9ef.png";
const insta =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742196631/instagram_przczs.png";
const face =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742196632/FacebookLogo_b3gby7.png";
const youtube =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742196691/youtube_ylqcgl.png";
  const das831 ="https://res.cloudinary.com/dafd4nkgz/image/upload/v1744701162/forage_harvester2_1_1_bedm6q.png";

const Header = () => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const [subdropdownOpen, setSubdropdownOpen] = useState(null);
  const [slidePanelOpen, setSlidePanelOpen] = useState(false);
  const [navActive, setNavActive] = useState(false);
  const [linkAnimations, setLinkAnimations] = useState(Array(6).fill(""));
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [rangeDropdownOpen, setRangeDropdownOpen] = useState(false); // Added for "OUR RANGE" dropdown in mobile

  // console.log(productId); // Safe to use productId here

  // const [showDropdown, setShowDropdown] = useState(false);

  // Function to load Google Translate script
  const loadGoogleTranslate = () => {
    if (!document.querySelector('script[src*="translate.google.com"]')) {
      const googleTranslateScript = document.createElement("script");
      googleTranslateScript.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.body.appendChild(googleTranslateScript);
    }
  };

  // const toggleRangeDropdown = () => setRangeDropdownOpen(!rangeDropdownOpen); // Toggle function for "OUR RANGE" dropdown
  const toggleRangeDropdown = () => {
    setRangeDropdownOpen(!rangeDropdownOpen);
    if (!rangeDropdownOpen) setDropdownOpen(false); // Close "ABOUT US" dropdown if range is opened
  };

  // Initialize Google Translate
  window.googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
      },
      "google_translate_element"
    );
  };

  useEffect(() => {
    loadGoogleTranslate();
  }, []);

  // const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
    if (!dropdownOpen) setRangeDropdownOpen(false); // Close range dropdown if "ABOUT US" is opened
  };
  const toggleSlidePanel = () => {
    setSlidePanelOpen(!slidePanelOpen);
    // document.body.classList.toggle('no-scroll', !slidePanelOpen);
  };

  const handleBurgerClick = () => {
    setNavActive(!navActive);
    if (navActive) {
      // document.body.classList.remove('no-scroll');
      setLinkAnimations(Array(6).fill(""));
      // window.scrollTo(0, 0);
    } else {
      // document.body.classList.add('no-scroll');

      setLinkAnimations(
        linkAnimations.map(
          (_, index) => `navLinkFade 0.5s ease forwards ${index / 6}s`
        )
      );
    }
  };

  const productImages = {
    "Dasmesh 9100": das9100,
    "Dasmesh 9100 Maize": das9100maize,
    "Dasmesh 7100": das7100,
    "Dasmesh 3100": das3100,
    "Dasmesh 912 2WD": das912tdc,
    "Dasmesh 912 4WD": das9124wd,
    "Dasmesh 731 Track": das731,
    "Dasmesh 726 Track": das726,
    "Dasmesh Maize Header": dasmaizehdr,
    "Dasmesh 831":das831,
    "Dasmesh Rotavator": rotavator,
    "Dasmesh Laser Land Leveller": daslll,
    "Dasmesh Super Seeder": dasss,
    "Dasmesh Straw Reaper": dassr,
    "Dasmesh Square Baler": dassb,
    "Dasmesh Round Baler": dasrb,
    "Dasmesh Hey Rake": dashr,
    "Dasmesh Zero Till Drill": dasztd,
    "Dasmesh DSR Drill": dasdd,
    "Dasmesh Paddy Straw Chopper": daspsc,
  };

  const combineHarvesterProducts = [
    { id: "1", productName: "Dasmesh 9100", subCate: "Combineharvester" },
    { id: "2", productName: "Dasmesh 9100 Maize", subCate: "Combineharvester" },
    { id: "3", productName: "Dasmesh 7100", subCate: "Combineharvester" },
    { id: "4", productName: "Dasmesh 3100", subCate: "Combineharvester" },
    { id: "5", productName: "Dasmesh 912 2WD", subCate: "Combineharvester" },
    { id: "6", productName: "Dasmesh 912 4WD", subCate: "Combineharvester" },
    { id: "7", productName: "Dasmesh 731 Track", subCate: "Combineharvester" },
    { id: "8", productName: "Dasmesh 726 Track", subCate: "Combineharvester" },
    {
      id: "9",
      productName: "Dasmesh Maize Header",
      subCate: "Combineharvester",
    },
     {
      id: "20",
      productName: "Dasmesh 831",
      subCate: "Combineharvester",
    },
  ];

  const agriImplementsProducts = [
    { id: "10", productName: "Dasmesh Rotavator", subCate: "agriImplements" },
    {
      id: "11",
      productName: "Dasmesh Laser Land Leveller",
      subCate: "agriImplements",
    },
    {
      id: "12",
      productName: "Dasmesh Super Seeder",
      subCate: "agriImplements",
    },
    {
      id: "13",
      productName: "Dasmesh Straw Reaper",
      subCate: "agriImplements",
    },
    {
      id: "19",
      productName: "Dasmesh Paddy Straw Chopper",
      subCate: "agriImplements",
    },
    {
      id: "14",
      productName: "Dasmesh Square Baler",
      subCate: "agriImplements",
    },
    { id: "15", productName: "Dasmesh Round Baler", subCate: "agriImplements" },
    { id: "16", productName: "Dasmesh Hey Rake", subCate: "agriImplements" },
    {
      id: "17",
      productName: "Dasmesh Zero Till Drill",
      subCate: "agriImplements",
    },
    { id: "18", productName: "Dasmesh DSR Drill", subCate: "agriImplements" },
    
  ];
  const handleExploreClick = (product) => {
    setSlidePanelOpen(false);
    setNavActive(false);
    const slug = createSlug(product.productName || product.modeldesc);
    navigate(`/${slug}`, { state: { product } });
    window.scrollTo(0, 0);
  };

  // console.log('slidePanelOpen', slidePanelOpen);

  const dekstopdown = () => {
    window.scrollTo({
      top: 0, // Vertical scroll position
      left: 0, // Horizontal scroll position (default: 0)
      behavior: "smooth", // Smooth scrolling
    });
  };

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        // Adjust the scroll distance as needed
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const currentPathSegment = window.location.pathname.replace(/^\/+|\/+$/g, "");
  const isProductPage = Boolean(currentPathSegment && fetchProductBySlugOrId(currentPathSegment));
  const isRelativeHeaderPage =
    isProductPage ||
    window.location.pathname.toLowerCase().includes("/product-detail/") ||
    window.location.pathname.includes("/general-enqiure");
  const headerClassName = `header ${
    isRelativeHeaderPage
      ? `relative ${isSticky ? "sticky" : ""}`
      : `fixed ${isSticky ? "sticky" : ""}`
  }`;

  // Handlers
  // const handleMouseEnter = (menu) => {
  //     setSubdropdownOpen(menu);
  // };

  // const handleMouseLeave = () => {
  //     setSubdropdownOpen(null);
  // };

  // const aboutGroupSection = (event) => {
  //     event.preventDefault();
  //     navigate('/Aboutdsamesh', { state: { targetid: 'group' } });
  //     // handleBurgerClick(false);
  // };

  // const aboutHistorySection = (event) => {
  //     event.preventDefault();
  //     navigate('/Aboutdsamesh', { state: { targetid: 'ourhistory' } });
  //     // handleBurgerClick(false);
  // };

  // const valuecoresection = (event) => {
  //     event.preventDefault();
  //     navigate(`/Aboutvalue/`, { state: { targetid: 'valuecores' } });

  // };

  // const valuecorpationsection = (event) => {
  //     event.preventDefault();
  //     navigate(`/Aboutvalue/`, { state: { targetid: 'corporatesvalues' } });

  // };

  return (
    <>
      <div className="hdr1">
        <div className="row" id="hdr1-space-bar">
          <div className="col-8">
       <div className="hdr1-mail-phone">
  <span>
    <i className="fa-solid fa-envelope"></i> sales@dasmesh.com
  </span>
  <span>
    <i className="fa-solid fa-phone"></i> 1800-5326-726
  </span>
<div className="custom-button-container">
  <a
    href="http://103.66.206.119:8085/apex/f?p=100:LOGIN_DESKTOP:11328605219091:::::"
    target="_blank"
    rel="noopener noreferrer"
    className="custom-angled-button"
  >
    Dealer Login
  </a>
  {/* <a href="#" className="custom-angled-button">Request Quote</a> */}
</div>


</div>

          </div>
          <div className="col-4">
            <div className="hdr1-social-translate">
              <div className="hdr1-social-media-section">
                <a
                  target="blank"
                  href="https://www.instagram.com/dasmeshgroup/"
                >
                  <img src={insta} alt="social" />
                </a>
                <a target="blank" href="https://www.facebook.com/dasmeshgroup">
                  <img src={face} alt="social" />
                </a>
                <a target="blank" href="https://www.youtube.com/dasmeshgroup">
                  <img src={youtube} alt="social" />
                </a>
              </div>
              <div id="google_translate_element"></div>
            </div>
          </div>
        </div>
      </div>
      <header className={headerClassName}>
        <div className="hdr2">
          <div className="row" id="hdr2-space-bar">
            <div className="col-lg-2 col-4">
              <div className="navbar-logo">
                <Link
                  onClick={() => {
                    window.scrollTo(0, 0); // Scroll to the top on page navigation
                  }}
                  to="/"
                >
                  <img src={logo} alt="logo" />
                </Link>
              </div>
            </div>
            <div className="col-lg-8 col-8">
              <nav className="hdr-navbar">
                {/* <div
                                 onMouseMove={handleMouseMove}
                                    className={`circle-cursor ${isHovering ? "active" : ""}`}
                                    style={{
                                        top: cursorPosition.y + "px",
                                        left: cursorPosition.x + "px",
                                    }}
                                ></div> */}
                <ul>
                  <li className="hdr-nav-under-link">
                    <div
                      className="dropdown"
                      onMouseEnter={toggleDropdown}
                      onMouseLeave={toggleDropdown}
                    >
                      <span className="dropdown-toggle">About Us</span>
                      {dropdownOpen && (
                        <div className="dropdown-menu-desk menu-2">
                          {/* <Link
                                                        className="main-link"
                                                        onMouseEnter={() => handleMouseEnter('aboutDasmesh')}
                                                        onMouseLeave={handleMouseLeave}
                                                    >
                                                        <span>
                                                            About Dasmesh <i className="fa-solid fa-chevron-right"></i>
                                                        </span>

                                                        <div
                                                            className={`dropdown-menu ${subdropdownOpen === 'aboutDasmesh' ? 'show' : ''}`}
                                                        >
                                                            <Link to="/Aboutdsamesh" onClick={() => window.scrollTo(0, 0)} className="dropdown-link">
                                                                ABOUT DASMESH
                                                            </Link>
                                                            <Link onClick={aboutGroupSection} className="dropdown-link">
                                                                GROUP COMPANIES
                                                            </Link>
                                                            <Link onClick={aboutHistorySection} className="dropdown-link">
                                                                ACCOMPLISHMENTS
                                                            </Link>
                                                        </div>
                                                    </Link>
                                                    <Link
                                                        // to="/Aboutvalue"
                                                        className="main-link"
                                                        onMouseEnter={() => handleMouseEnter("ourvalue")}
                                                        onMouseLeave={handleMouseLeave}

                                                    >
                                                        <span>Our Value  <i class="fa-solid fa-chevron-right"></i></span>

                                                        <div
                                                            className={`dropdown-menu ${subdropdownOpen === 'ourvalue' ? 'show' : ''}`}
                                                        >
                                                            <Link to="/Aboutvalue" onClick={() => window.scrollTo(0, 0)} className="dropdown-link">
                                                                OUR VALUE
                                                            </Link>
                                                            <Link onClick={valuecoresection} className="dropdown-link">
                                                                Core VALUES
                                                            </Link>
                                                            <Link onClick={valuecorpationsection} className="dropdown-link">
                                                                Corporate Values
                                                            </Link>
                                                        </div>
                                                    </Link> */}
                          <Link onClick={dekstopdown} to="/Aboutdsamesh">
                            <span>About Dasmesh</span>
                          </Link>
                          <Link onClick={dekstopdown} to="/Aboutvalue">
                            <span>Our Vision</span>
                          </Link>
                          {/* <Link to="/Aboutglovalreach"><span>OUR GLOBAL REACH</span></Link> */}
                          <Link onClick={dekstopdown} to="/Aboutfacility">
                            <span>Facilities</span>
                          </Link>
                          <Link onClick={dekstopdown} to="/Aboutaward">
                            <span>Award & Certificates</span>
                          </Link>
                          <Link onClick={dekstopdown} to="/Aboutcmdmessage">
                            <span>CMD’s Message</span>
                          </Link>
                          <Link onClick={dekstopdown} to="/Aboutpolicy">
                            <span>Quality Policy</span>
                          </Link>
                        </div>
                      )}
                    </div>
                  </li>
                  {/* onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} */}
                  <li className="hdr-nav-under-link">
                    <Link onClick={() => toggleSlidePanel()}>
                      <span>Our Range</span>
                    </Link>
                  </li>
                  <li className="hdr-nav-under-link">
                    <Link to="/contact" onClick={dekstopdown}>
                      <span>Reach Us</span>
                    </Link>
                  </li>
                </ul>
              </nav>

              <nav className="hdr-navbar-mobile-view">
                <div
                  className={`burger ${navActive ? "toggle" : ""}`}
                  onClick={handleBurgerClick}
                >
                  <div className="line-1"></div>
                  <div className="line-2"></div>
                  <div className="line-3"></div>
                </div>

                <ul className={`nav-links ${navActive ? "nav-active" : ""}`}>
                  <li
                    style={{ animation: linkAnimations[0] }}
                    onClick={() => {
                      setNavActive(false);
                      window.scrollTo(0, 0); // Scroll to the top on page navigation
                    }}
                  >
                    <Link to="/">HOME</Link>
                  </li>
                  <li style={{ animation: linkAnimations[1] }}>
                    <div
                      className="dropdown"
                      onMouseEnter={toggleDropdown}
                      onMouseLeave={toggleDropdown}
                    >
                      <Link
                        className={`dropdown-toggle ${
                          dropdownOpen ? "open" : ""
                        }`}
                      >
                        About Us
                      </Link>
                      {dropdownOpen && (
                        <div className="dropdown-menu menu-2">
                          <Link
                            onClick={() => {
                              setNavActive(false);
                              window.scrollTo(0, 0); // Scroll to the top on page navigation
                            }}
                            to="/Aboutdsamesh"
                          >
                            About Dasmesh
                          </Link>
                          {/* <Link
                                                        onClick={() => {
                                                            setIsOpen(!isOpen); // Toggle submenu
                                                            setSubmenuActive(!submenuActive); // Update submenu active state
                                                            window.scrollTo(0, 0); // Scroll to the top
                                                        }}
                                                        to="/AboutDasmesh"
                                                        className={submenuActive ? "active-link" : ""}
                                                    >
                                                        About Dasmesh <i class="fa-solid fa-chevron-down"></i>
                                                    </Link>
                                                    <div className={`dropdown-links ${isOpen ? "show" : ""}`}>
                                                        {isOpen && (
                                                            <>
                                                                <p onClick={aboutgroupsection} className="dropdown-link">
                                                                    GROUP COMPANIES
                                                                </p>
                                                                <p onClick={abouthistorysection} className="dropdown-link">
                                                                    ACCOMPLISHMENTS
                                                                </p>
                                                            </>
                                                        )}
                                                    </div> */}

                          {/* <Link
                                                        to="/Aboutdsamesh"
                                                        className="main-link"
                                                        onClick={(e) => {
                                                            // e.preventDefault();
                                                            handleBurgerClick(false);
                                                            toggleSubmenu("aboutDasmesh");
                                                        }}
                                                    >
                                                        <span>About Dasmesh</span>
                                                    </Link>
                                                    {openSubmenus["aboutDasmesh"] && (
                                                        <div className="submenu">
                                                            <p onClick={aboutgroupsection} className="dropdown-link">GROUP COMPANIES</p>
                                                            <p onClick={abouthistorysection} className="dropdown-link">ACCOMPLISHMENTS</p>
                                                        </div>
                                                    )}
                                                    <Link
                                                        to="/Aboutvalue"
                                                        className="main-link"
                                                        onClick={(e) => {
                                                            handleBurgerClick(false);
                                                            // e.preventDefault();
                                                            window.scrollTo(0, 0);
                                                            toggleSubmenu("aboutValue");
                                                        }}
                                                    >
                                                        <span>About Value</span>
                                                    </Link>
                                                    {openSubmenus["aboutValue"] && (
                                                        <div className="submenu">
                                                            <p onClick={valuecoresection} className="dropdown-link">Core VALUES</p>
                                                            <p onClick={valuecorpationsection} className="dropdown-link">Corporate Values</p>
                                                        </div>
                                                    )} */}

                          {/* <Link onClick={() => setNavActive(false)} to="/Ourhistory">Our History</Link> */}
                          <Link
                            onClick={() => {
                              setNavActive(false);
                              window.scrollTo(0, 0); // Scroll to the top on page navigation
                            }}
                            to="/Aboutvalue"
                          >
                            Our Vision
                          </Link>

                          {/* <Link onClick={() => setNavActive(false)} to="/Aboutglovalreach">OUR GLOBAL REACH</Link> */}
                          <Link
                            onClick={() => {
                              setNavActive(false);
                              window.scrollTo(0, 0); // Scroll to the top on page navigation
                            }}
                            to="/Aboutfacility"
                          >
                            Facilities
                          </Link>
                          <Link
                            onClick={() => {
                              setNavActive(false);
                              window.scrollTo(0, 0); // Scroll to the top on page navigation
                            }}
                            to="/Aboutaward"
                          >
                            Awards & Certificates
                          </Link>
                          <Link
                            onClick={() => {
                              setNavActive(false);
                              window.scrollTo(0, 0); // Scroll to the top on page navigation
                            }}
                            to="/Aboutcmdmessage"
                          >
                            CMD’s Message
                          </Link>
                          <Link
                            onClick={() => {
                              setNavActive(false);
                              window.scrollTo(0, 0); // Scroll to the top on page navigation
                            }}
                            to="/Aboutpolicy"
                          >
                            Quality Policy
                          </Link>
                        </div>
                      )}
                    </div>
                  </li>
                  <li style={{ animation: linkAnimations[2] }}>
                    <div className="dropdown" onClick={toggleRangeDropdown}>
                      <Link
                        className={`dropdown-toggle ${
                          rangeDropdownOpen ? "open" : ""
                        }`}
                      >
                        Our Range
                      </Link>
                      {rangeDropdownOpen && (
                        <div className="dropdown-menu menu-2">
                          <div className="row">
                            <div className="col-6">
                              <div className="product-range-youtube">
                                <h3>COMBINE HARVESTER</h3>
                                <div className="product-range-youtube-img-details">
                                  <ul>
                                    {combineHarvesterProducts.map(
                                      (product, dektopdex) => (
                                        <li
                                          key={dektopdex}
                                          className="product-hdr-mobile-link"
                                        >
                                          <span
                                            onClick={() =>
                                              handleExploreClick(product)
                                            }
                                          >
                                            {product.productName}
                                          </span>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="product-range-youtube">
                                <h3>AGRI. IMPLEMENTS</h3>
                                <div className="product-range-youtube-img-details">
                                  <ul>
                                    {agriImplementsProducts.map(
                                      (product, deskexsc) => (
                                        <li
                                          key={deskexsc}
                                          className="product-hdr-mobile-link"
                                        >
                                          <span
                                            onClick={() =>
                                              handleExploreClick(product)
                                            }
                                          >
                                            {product.productName}
                                          </span>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </li>
                  <li
                    style={{ animation: linkAnimations[5] }}
                    onClick={() => setNavActive(false)}
                  >
                    <Link
                      onClick={() => {
                        setNavActive(false);
                        window.scrollTo(0, 0); // Scroll to the top on page navigation
                      }}
                      to="/contact"
                    >
                      Reach Us
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </header>

      <div className={`slide-panel ${slidePanelOpen ? "open" : ""}`}>
        <button className="close-panel" onClick={toggleSlidePanel}>
          X
        </button>
        <div className="slide-panel-content">
          <h2>Our Range</h2>
          <div className="row">
            <div className="col-6">
              <div className="row">
                <div className="col-6">
                  <div className="hdr-product-range">
                    <h3>COMBINE HARVESTER</h3>
                    <div className="hdr-products-links">
                      <ul>
                        {combineHarvesterProducts.map((product, innerdex) => (
                          <li key={innerdex}>
                            <span
                              className="agri-link"
                              onMouseEnter={() =>
                                setHoveredProduct(product.productName)
                              }
                              onMouseLeave={() => setHoveredProduct(null)}
                              onClick={() => handleExploreClick(product)}
                            >
                              {product.productName}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="hdr-product-range">
                    <h3>AGRI. IMPLEMENTS</h3>
                    <div className="hdr-products-links">
                      <ul>
                        {agriImplementsProducts.map((product, innersecdex) => (
                          <li key={innersecdex}>
                            <span
                              className="agri-link"
                              onMouseEnter={() =>
                                setHoveredProduct(product.productName)
                              }
                              onMouseLeave={() => setHoveredProduct(null)}
                              onClick={() => handleExploreClick(product)}
                            >
                              {product.productName}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6" id="hdrlinepart-productsrange">
              <div className="our-prod-range-hdr">
                {hoveredProduct && (
                  <img src={productImages[hoveredProduct]} alt="Product" />
                )}
              </div>
              {hoveredProduct && <p>{hoveredProduct}</p>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
